import React from 'react'
import { Link } from '@ta-interaktiv/contentbricks'
export const qanda = [
  {
    q: 'Les masques protègent-ils contre les infections?',
    a: (
      <>
        Une équipe dirigée par l'épidémiologiste anglais Tom Jefferson, de
        l'Université d'Oxford, a{' '}
        <Link href='https://www.medrxiv.org/content/10.1101/2020.03.30.20047217v2'>
          récemment
        </Link>{' '}
        passé en revue quatorze études pour enfin répondre à la question de
        savoir dans quelle mesure les masques protègent réellement contre les
        infections virales. Le résultat n'est pas très satisfaisant pour ceux
        qui aiment les réponses claires: l'équipe de Jefferson n'a pas trouvé la
        preuve concrète de l’effet des masques sur le nombre d'infections. Ce
        n'est qu'en combinaison avec d'autres mesures que les masques pourraient
        être efficaces. Dans une interview à la télévision alémanique, Tom
        Jefferson a proposé que la situation actuelle soit mise à profit pour
        lancer d'autres études sur le sujet. Un{' '}
        <Link href='https://www.bmj.com/content/369/bmj.m1435'>article</Link> du
        British Medical Journal, auquel le néonatologiste suisse Manuel Schmid a
        collaboré, n'a pas non plus réussi à prouver clairement que les masques
        protègent contre l'infection par le coronavirus. Mais les chercheurs
        sont néanmoins arrivés à la conclusion suivante: «Le Covid-19 étant une
        menace très sérieuse, nous recommandons de porter des masques en
        public.» Même un petit effet pourrait sauver des vies, estiment les
        scientifiques. Il y a quelques jours, une équipe sino-britannique s'est
        également exprimée en faveur du port de masques dans la revue
        scientifique{' '}
        <Link href='https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(20)30918-1/fulltext'>
          Lancet
        </Link>{' '}
        . Les auteurs ont écrit que le port d'un masque n’a pas grand impact au
        niveau individuel, mais en tant que mesure globale, si tout le monde y
        adhérait, il pourrait aider à contenir l'épidémie.
      </>
    )
  },
  {
    q: 'Comment le masque protège-t-il?',
    a: (
      <>
        Si l'objectif principal est de se protéger des virus des autres, les
        simples masques en tissu et les masques d'hygiène sont peu utiles, car
        ils n’isolent pas hermétiquement la bouche et le nez. Ces masques
        empêchent certes les grosses particules d'entrer, mais ne sont pas
        équipés de filtres pour protéger contre les virus. En effet, les
        coronavirus sont environ 1000 fois plus petits que la section d'un
        cheveu et passent donc par les interstices entre les fibres du papier
        des masques. L'agent pathogène peut être aspiré par les ouvertures
        latérales des masques lors de la respiration. Ou bien le virus peut
        s'accrocher à des masques de classe de protection inférieure et pénétrer
        dans le corps lors de la prochaine respiration. Seuls les masques
        spécialisés N95 peuvent protéger. Ils n'offrent pas une sécurité
        absolue, mais atteignent des valeurs très élevées lors des tests.
        Toutefois, les masques N95 sont réservés au personnel soignant qui
        s'occupent quotidiennement de personnes infectées et ne sont pas
        destinés à la population générale, car le matériel disponible est encore
        insuffisant. Les masques FFP avec une valve au milieu sont souvent
        montrés dans les médias. L'Institut fédéral allemand des médicaments et
        des dispositifs médicaux (BfArM) explique que «les masques sans valve
        filtrent à la fois l'air inhalé et l'air expiré et offrent donc à la
        fois une autoprotection et une protection contre les corps étrangers.
        Les masques à valve ne filtrent que l'air inhalé et ne sont donc pas
        conçus pour la protection des autres.» On peut également être infecté
        par des gouttelettes qui pénètrent dans l'œil. C’est la raison pour
        laquelle, le personnel soignant porte aussi des lunettes de protection
        ou un garde-face, qui est une espèce de vitre de protection.
      </>
    )
  },
  {
    q: 'Comment le masque protège-t-il les autres?',
    a: (
      <>
        Le port de masques protège avant tout les autres de sa propre infection,
        ce qui fait dire au virologue allemand Christian Drosten que le fait de
        porter un masque en public est un «geste de politesse». Si tout le monde
        met un masque en public, il y a aussi un effet de protection collective
        pour la personne qui le porte: on est protégé parce que la personne d'en
        face, qui ne sait peut-être pas encore qu'elle est infectée, porte
        également un masque. On a de plus en plus de raisons de penser que les
        personnes infectées sont contagieuses un ou deux jours avant de tomber
        malades. On appelle cela l’état présymptomatique. Dans une{' '}
        <Link href='https://www.nature.com/articles/s41591-020-0869-5#Fig1'>
          nouvelle étude
        </Link>{' '}
        réalisée en Chine, les auteurs supposent que 44% des nouvelles
        infections surviennent avant que quiconque ne présente des symptômes.
        D’une façon générale, on en sait encore trop peu sur le nouveau
        coronavirus et son mode de transmission. Par exemple, la question de
        savoir si le virus se propage aussi par les aérosols est toujours
        ouverte. Mais cette question est cruciale lorsqu'il s'agit de savoir si
        les masques d’hygiène simples sont efficaces ou insuffisants. Les
        aérosols sont de minuscules gouttelettes que l'on disperse lorsque l'on
        parle. Les masques en tissu et les masques d’hygiène ou chirurgicaux
        sont les plus susceptibles de retenir les plus grosses gouttelettes
        qu’on vaporise lorsqu’on tousse ou qu’on éternue. En revanche ces
        masques ne bloquent pas complètement les aérosols. Ils peuvent néanmoins
        réduire fortement la quantité de virus pulvérisés. Dans une étude
        publiée dans le magazine{' '}
        <Link href='https://www.nature.com/articles/s41591-020-0843-2'>
          «Nature Medicine»
        </Link>{' '}
        début avril, les auteurs ont montré que même de simples masques
        réduisent au moins la quantité de virus qu'une personne infectée peut
        diffuser. Lorsqu’on éternue ou qu’on tousse sans tenir le coude devant
        la bouche, des gouttelettes peuvent être projetées dans l'environnement
        à 180 km/h et voler plus loin que la distance minimale de 2 mètres. Même
        le port d'un simple masque empêche les virus de se propager sans
        contrôle.
      </>
    )
  },
  {
    q: "Pourquoi l'OFSP déconseille-t-il encore le port des masques?",
    a: (
      <>
        Les masques n'offrent «aucune protection réelle contre les virus», a
        déclaré à plusieurs reprises Daniel Koch, de l'OFSP. Le{' '}
        <Link href='https://www.bag.admin.ch/bag/fr/home/krankheiten/ausbrueche-epidemien-pandemien/aktuelle-ausbrueche-epidemien/novel-cov/haeufig-gestellte-fragen.html'>
          site de l'OFSP
        </Link>{' '}
        indique même explicitement que «les personnes en bonne santé ne doivent
        pas porter de masque d'hygiène en public». Ces derniers ne protégeraient
        pas efficacement contre l'infection. Pendant longtemps, il y a aussi eu
        trop peu de masques en Suisse, c'est pourquoi la première priorité a
        toujours été de fournir ces masques en quantité suffisante au personnel
        soignant. La pénurie semble désormais comblée. «Il ne devrait plus y
        avoir de pénurie de masques», estime Daniel Koch. Actuellement, la
        Confédération dispose d'environ 20 millions de masques de protection, et
        d'ici à la fin d’avril il devrait en avoir 100 millions. L'OFSP n'a pas
        l'intention d'introduire une obligation générale de porter des masques
        dans un avenir proche, comme l'a encore déclaré Patrick Mathys, de
        l'OFSP, lors de la conférence de presse du 20 avril. Néanmoins, les
        masques joueront désormais un rôle plus important dans les concepts de
        protection individuelle, par exemple lors d'une visite chez le coiffeur.
        Dans un avenir proche, la question de savoir si le port du masque sera
        également obligatoire dans les transports publics ou lors des achats
        reste ouverte. Mais Patrick Mathys laisse entendre que les masques
        d’hygiène joueront un rôle plus important qu'auparavant dans le concept
        du Conseil fédéral.
      </>
    )
  },
  {
    q: 'Que recommandent les autres autorités?',
    a: (
      <>
        Le Center for Disease Control and Prevention américain (CDC) et
        l'institut allemand Robert Koch (RKI) ont également déconseillé, dans un
        premier temps, l’utilisation d’un masque à la population générale.
        Aujourd'hui, tous deux ont changé d'avis: le port de masques en tissu
        non médical (même faits maison) est recommandé partout où il est
        difficile de se tenir à distance des autres – par exemple dans les
        supermarchés et les pharmacies. Le RKI corrige également le tir et
        conseille désormais de porter un masque à titre préventif pour les
        rhumes, afin de ne pas mettre en danger les autres en éternuant, par
        exemple – et dans certains les lieux publics, comme dans les transports
        publics. Il est toutefois important de manipuler le masque correctement.
        L'Organisation mondiale de la santé (OMS) a également{' '}
        <Link href='https://www.who.int/publications-detail/advice-on-the-use-of-masks-in-the-community-during-home-care-and-in-healthcare-settings-in-the-context-of-the-novel-coronavirus-(2019-ncov)-outbreak'>
          déclaré
        </Link>{' '}
        , le 6 avril, que les masques pourraient effectivement contribuer à la
        limitation de la propagation du virus Sars-CoV-2.
      </>
    )
  },
  {
    q: 'Que recommande un épidémiologiste sud-coréen à la Suisse?',
    a: (
      <>
        L’appel à la population suisse est lancé à 9000 kilomètres d'ici. Tous
        les habitants de la Suisse devraient porter des masques de protection
        pour lutter contre le Covid-19, comme cela a été fait en Corée du Sud.
        L'épidémiologiste Chun Byung-chul le recommande dans une lettre adressée
        à un médecin suisse. L'expert de l'Université de Corée vit lui-même en
        Corée du Sud – qui est considérée comme le pays qui a contenu la
        propagation du virus sans bloquer toute la vie publique. Selon Chun
        Byung-chul, les premiers symptômes de Covid-19 sont très légers, ce qui
        rend difficile de dire qui est infecté et qui ne l'est pas. «Les masques
        peuvent réduire la propagation des gouttelettes contenant le virus.»
        Bien qu'il n'existe pas d'études qui prouvent un effet épidémiologique
        des masques d’hygiène et artisanaux, celui-ci est constaté dans la
        pratique clinique. Chun Byung-chul précise que ses recommandations sont
        également adressées au Conseil fédéral. George Gao, virologiste et
        directeur du Centre chinois de contrôle et de prévention des maladies, a
        également publié une mise en garde dans la revue{' '}
        <Link href='https://www.sciencemag.org/news/2020/03/not-wearing-masks-protect-against-coronavirus-big-mistake-top-chinese-scientist-says'>
          «Science»:
        </Link>{' '}
        «Les États-Unis et l'Europe font une grosse erreur en ne faisant pas
        porter de masques à leurs habitants. De nombreuses personnes sont
        atteintes d'une infection asymptomatique ou présymptomatique. S'ils
        portaient un masque, cela pourrait empêcher les gouttelettes qui
        transmettent le virus de s'échapper et d'infecter d'autres personnes».
        De nombreux pays européens suivent déjà ces conseils. En République
        tchèque, par exemple, personne n'est autorisé à quitter la maison sans
        se couvrir la bouche et le nez. En Allemagne, les masques de tous les
        jours ou, en remplacement, les foulards ou les écharpes sont désormais
        obligatoires dans dix des seize États fédéraux. Jusqu'à présent, il n'y
        a pas de consigne uniforme: la chancelière Angela Merkel n'a fait que
        «recommander fortement» le port de masques dans les bus et les trains
        ainsi que dans les magasins de détail. En Autriche, les citoyens devront
        porter des protections buccales et nasales dans les supermarchés jusqu'à
        nouvel avis.
      </>
    )
  },
  {
    q:
      'Quelles sont les branches qui prévoient de rendre les masques obligatoires pour les employés en Suisse?',
    a: (
      <>
        Dans un document de réflexion, l'Association suisse des moniteurs
        d'auto-école propose un «port obligatoire du masque de protection pour
        les apprentis conducteurs». Le commerce de détail y réfléchit également:
        l'Association des succursales suisses préconise des «exigences
        hygiéniques plus strictes» pour permettre à de nombreux magasins de
        rouvrir rapidement. Les projets de Coiffure Suisse, l'association des
        coiffeurs suisses, sont les plus avancés. Non seulement l’association
        prévoit une obligation de port de masque pour les coiffeurs et leurs
        clients, mais elle a déjà un concept pour l'approvisionnement en
        matériaux. Les hôteliers et les restaurateurs travaillent également sur
        des projets visant à accueillir de nouveau les clients dans un
        environnement sûr. «Les masques pourraient être un élément utile pour
        soutenir la sortie du confinement», affirme l'association
        professionnelle Hotelleriesuisse.
      </>
    )
  },
  {
    q: 'Peut-on réutiliser un masque?',
    a: (
      <>
        En fait, jusqu'avant l'épidémie, il était clairement recommandé de ne
        pas utiliser deux fois un masque d'hygiène et de le remplacer dès qu'il
        devenait trop humide. Mais à une époque où tous les équipements médicaux
        sont rares, des règles différentes s'appliquent. En ce qui concerne les
        masques d’hygiène ou en tissu, le virologiste Christian Drosten, de
        l'Hôpital de la Charité, à Berlin, assure qu'il suffit de les mettre
        dans le four à 70 degrés jusqu'à ce qu'ils soient secs. De cette façon,
        ils pourraient être utilisés deux fois, mais toujours par la même
        personne. Les masques en tissu sont également lavables à 60 degrés. Lors
        de la manipulation des masques, il faut également faire attention à ne
        pas toucher l'avant, où se trouvent la plupart des virus. Les masques en
        papier ne doivent pas être nettoyés avec des désinfectants, car cela
        endommage le masque.
      </>
    )
  },
  {
    q: 'Peut-on stériliser les masques de protection au micro-onde?',
    a: (
      <>
        Non. Pour nettoyer les masques en tissu, vous devez les laver dans la
        machine à laver, de préférence à 60 degrés. Des incendies se sont déjà
        produits aux États-Unis parce que des personnes ont essayé de stériliser
        au micro-onde leurs masques, dont une partie métallique sert de
        pince-nez.
      </>
    )
  },
  {
    q: 'Que valent les masques en tissu (faits maison)?',
    a: (
      <>
        Si possible, ils doivent être fabriqués en coton pour pouvoir être lavés
        à chaud, et ils doivent posséder plusieurs couches. Les masques en tissu
        ne protègent pas le porteur contre les infections. Mais ils protègent
        les autres, dans une certaine mesure, contre vos projections de
        postillons. L'incertitude est toutefois très grande avec les masques
        faits main, car ils ne sont pas testés. «L'effet protecteur de ces
        masques n'est pas prouvé mais, en tant que signal visuel, ils peuvent
        contribuer à garantir que les règles de distance sont respectées et que
        le porteur ressent moins de gêne au visage», déclare Lukas Jaggi,
        porte-parole de Swissmedic, l'Institut suisse des produits
        thérapeutiques.
      </>
    )
  },
  {
    q: 'Peut-on aussi me mettre un foulard sur son visage?',
    a: (
      <>
        Le foulard doit être aussi serré qu'un masque, alors à peu près la même
        chose s'applique en termes d'efficacité qu'un masque fait maison en
        tissu: un certain degré de protection pour les autres; une protection
        pour soi-même seulement si tout le monde le fait. Ces tissus peuvent en
        effet offrir un certain degré de protection. Ils représentent une
        barrière qui empêche ses propres gouttelettes d'être projetées fortement
        dans l'environnement. Les agents pathogènes de l'extérieur ont également
        davantage de peine à atteindre la bouche et le nez. Toutefois, les
        experts mettent en garde contre une utilisation abusive.
      </>
    )
  },
  {
    q: "Quel est le risque lié au port d'un masque?",
    a: (
      <>
        Un masque ne vous dispense pas de respecter les règles habituelles
        pendant cette pandémie. Il ne faut pas céder à un faux sentiment de
        sécurité: même avec un masque, la distance sociale et le lavage des
        mains fréquent restent essentiels. Un masque peut toutefois aider à
        réduire le nombre de contacts de ses mains avec son propre visage. Selon
        l'Institut Robert Koch, le masque ou «une autre forme de barrière»
        pourrait conduire à ce que «la règle de la distance ne soit plus
        respectée ou que l'hygiène des mains ne soit plus mise en œuvre». Sinon,
        les experts expliquent que, tant que la question de savoir s'ils
        assurent effectivement une protection efficace contre le nouveau
        coronavirus n'aura pas été clarifiée, le principe de «même si cela
        n'aide pas, cela ne nuit pas» s'applique. Adrien Burch, microbiologiste
        à l'Université de Californie à Berkeley,{' '}
        <Link href='https://www.sciencemag.org/news/2020/03/not-wearing-masks-protect-against-coronavirus-big-mistake-top-chinese-scientist-says'>
          préconise donc
        </Link>{' '}
        lui aussi le port du masque. Dans le cas des Sars, auxquels le virus
        Sars-CoV-2 actuel est lié, ils auraient fourni une protection
        significative – à la fois les simples masques d'hygiène et les masques
        FFP.
      </>
    )
  },
  {
    q: 'Doit-on porter un masque quand on fait du jogging?',
    a: (
      <>
        Les règles de distance s'appliquent également au jogging. Si possible,
        vous devez donc courir là où il y a peu de monde et respecter les règles
        de distance normales. Il n'y a donc aucune raison de porter un masque,
        ce qui pourrait rendre la course plus difficile. Par mesure de
        précaution, vous ne devez pas courir trop près derrière un autre
        coureur. Il est donc préférable de courir côte à côte plutôt que l'un
        derrière l'autre. Ou alors de façon légèrement décalée.
      </>
    )
  },
  {
    q: 'Les enfants doivent-ils porter un masque?',
    a: (
      <>
        Les enfants de moins de 2 ans ne doivent pas porter de masque. Pour les
        enfants de maternelle et les écoliers, cela peut avoir un sens dans
        certaines situations en public ou en contact avec des groupes à risque.
        Cependant, il est plus difficile pour les petits enfants de suivre les
        règles de bon usage des masques. Les enfants en bonne santé n'ont pas
        besoin de masque car ils ne tombent presque jamais gravement malades du
        Covid-19.
      </>
    )
  },
  {
    q: 'Doit-on porter un masque à la maison?',
    a: (
      <>
        Il est logique de porter un masque à la maison si vous êtes vous-même
        malade et que vous voulez protéger ceux qui habitent avec vous contre
        les infections. Un masque à la maison peut également être utile si vous
        vivez avec une personne qui appartient à un groupe à risque. Vous pouvez
        réduire le risque d'infection pour cette personne en portant vous-même
        un masque.
      </>
    )
  },
  {
    q: 'Y a-t-il assez de masques?',
    a: (
      <>
        Pendant de nombreuses semaines, il n’y avait pas assez masques en
        Suisse, c’est pourquoi la première priorité a toujours été de s’assurer
        que le personnel soignant en disposait en quantité suffisante.La pénurie
        semble maintenant avoir été comblée. Selon la ministre de la Défense
        Viola Amherd, la Confédération a acheté 100 millions de masques
        d’hygiène au début du mois d’avril. Les masques de protection sont très
        demandés dans le monde entier, a expliqué la conseillère fédérale. À
        l’heure actuelle, pratiquement seuls les États peuvent encore se
        procurer des masques. Le gouvernement suisse soutient donc les
        industries dans leurs achats. Parmi les masques de protection
        respiratoire (FFP2, FFP3), qui sont principalement réservés au personnel
        médical, la Suisse dispose d’environ 1,2 million d’unités en stock. A
        partir de la mi-mai, 80’000 à 100’000 d’entre eux peuvent être produits
        en Suisse chaque jour. Selon Viola Amherd, les machines de production
        sont arrivées en Suisse. «Il ne devrait plus y avoir de pénurie pour les
        masques», a déclaré Daniel Koch, de l’OFSP. Pour l’instant, il devrait y
        avoir suffisamment de masques.
      </>
    )
  },
  {
    q: 'Où peut-on acheter des masques?',
    a: (
      <>
        Le Conseil fédéral a rappelé que le secteur de la santé comme les
        hôpitaux et les cabinets médicaux, les entreprises et les ménages privés
        doivent en principe se procurer eux-mêmes les masques. Mais comme ces
        derniers sont actuellement très demandés, la Confédération fait
        également des achats sur le marché mondial avec sa toute puissance
        financière. Près de 400 millions de francs suisses ont été budgétisés
        pour les masques d’hygiène pour la seule population. Dorénavant, la
        pharmacie de l’armée fournira un million de masques d’hygiène par jour
        aux détaillants pendant deux semaines. Ils les vendent au prix d’achat.
        Jusqu’à présent, 21 millions de pièces ont été distribuées aux cantons.
        Les stocks fédéraux actuels comprennent 18 millions de masques
        d’hygiène. Parmi les détaillants, Coop, Migros et Volg ont jusqu’à
        présent confirmé qu’ils allaient vendre des masques d’hygiène de la
        Confédération. Ils n’ont fourni aucune information sur le prix exact.
        Afin d’éviter l’achat de hamsters, une seule boîte de 50 masques par
        client et par achat est autorisée. Bien sûr, les clients pourraient
        revenir après avoir quitté le magasin et acheter une deuxième boîte,
        écrit un porte-parole de Migros. «Nous ne jouons pas aux policiers.»
        Bientôt, Coop proposera dans sa boutique en ligne des masques que le
        grossiste s’est lui-même procuré sur le marché. Il en va de même pour
        Migros, qui proposera certains masques via les boutiques en ligne de ses
        filiales Do it + Garden et Galaxus. De nombreuses pharmacies vendent
        désormais aussi des masques d’hygiène simples.
      </>
    )
  }
]
